"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsFactory = void 0;
const Source_1 = require("../../models/searchservice/response/Source");
const HighlightedValueFactory_1 = require("./HighlightedValueFactory");
/**
 * A factory which creates results from different sources
 */
class ResultsFactory {
    static create(results, source) {
        return results.map((result, index) => {
            result = Object.assign(Object.assign({}, result), { index: index + 1 });
            switch (source) {
                case Source_1.Source.KnowledgeManager:
                    return this.fromKnowledgeManager(result);
                case Source_1.Source.Google:
                    return this.fromGoogleCustomSearchEngine(result);
                case Source_1.Source.Bing:
                    return this.fromBingCustomSearchEngine(result);
                case Source_1.Source.Zendesk:
                    return this.fromZendeskSearchEngine(result);
                case Source_1.Source.Algolia:
                    return this.fromAlgoliaSearchEngine(result);
                default:
                    return this.fromGeneric(result);
            }
        });
    }
    static fromKnowledgeManager(result) {
        var _a;
        const rawData = (_a = result.data) !== null && _a !== void 0 ? _a : {};
        return Object.freeze({
            rawData: rawData,
            source: Source_1.Source.KnowledgeManager,
            index: result.index,
            name: rawData.name,
            description: rawData.description,
            link: rawData.website,
            id: rawData.id,
            distance: result.distance,
            distanceFromFilter: result.distanceFromFilter,
            highlightedValues: HighlightedValueFactory_1.HighlightedValueFactory.create(result.highlightedFields),
            entityType: rawData.type
        });
    }
    static fromGoogleCustomSearchEngine(result) {
        return Object.freeze({
            rawData: result,
            source: Source_1.Source.Google,
            index: result.index,
            name: result.htmlTitle.replace(/(<([^>]+)>)/ig, ''),
            description: result.htmlSnippet,
            link: result.link
        });
    }
    static fromBingCustomSearchEngine(result) {
        return Object.freeze({
            rawData: result,
            source: Source_1.Source.Bing,
            index: result.index,
            name: result.name,
            description: result.snippet,
            link: result.url
        });
    }
    static fromZendeskSearchEngine(result) {
        return Object.freeze({
            rawData: result,
            source: Source_1.Source.Zendesk,
            index: result.index,
            name: result.title,
            description: result.snippet,
            link: result.html_url
        });
    }
    static fromAlgoliaSearchEngine(result) {
        return Object.freeze({
            rawData: result,
            source: Source_1.Source.Algolia,
            index: result.index,
            name: result.name,
            id: result.objectID
        });
    }
    static fromGeneric(result) {
        return Object.freeze({
            rawData: result,
            source: Source_1.Source.Generic,
            index: result.index,
            name: result.name,
            description: result.description,
            link: result.website,
            id: result.id,
        });
    }
    static fromDirectAnswer(result) {
        var _a;
        const rawData = (_a = result.fieldValues) !== null && _a !== void 0 ? _a : {};
        return Object.freeze({
            rawData: rawData,
            source: Source_1.Source.KnowledgeManager,
            name: rawData.name,
            description: rawData.description,
            link: result.website,
            id: result.id,
            entityType: result.type,
        });
    }
}
exports.ResultsFactory = ResultsFactory;
